<template>
  <div class="upload-box">
    <div class="upload-btn" id="uploadBtnDiv">
          <ejs-button class="e-input" isPrimary='true' @click.native='upButton' >{{$t("MML.upload")}}</ejs-button>
    </div>
    <progress-bar v-show='showProgressBar' ref='progressBar' :val='progressVal' :text='progressText' class="upload-progress"></progress-bar>
    <div class='h-system-hide-upload'>
      <ejs-uploader ref='file' name='file' id='file' autoUpload='false' :selected='onFileSelect'

                    :multiple='false'></ejs-uploader>
    </div>
  </div>
</template>


<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../../../../plugins/eventBus';
  import ShowProgress from '@/components/mmlconfig/respItem/ShowProgress';
  import packageParams from '@/components/mmlconfig/mixins/packageParams';
  import mmlSocket from '@/plugins/stompSock';
  import { createNamespacedHelpers } from 'vuex';
  const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
  export default {
    name: 'addDialog',
    components: {
      ProgressBar,
      ShowProgress
    },
    mixins: [packageParams],
    data() {
      return {
        extensions: '.tar.gz,.zip,.pkg',
        showProgressBar: false,
        progressVal: 0,
        progressText: '0%',
        versionShow: false,
        deliverType: [
          {text: 'Native', value: 0},
          {text: 'Image', value: 1},
          {text: 'Helm', value: 2},
          {text: 'VM', value: 3}
        ],
        versionSource: [],
        brokenFlag:0,
        payload: [
          { topic: '/user/#/MMLServer', clientId: this.getUserId(), callback: this.mmlWebsocketLisener }
        ],
      }
    },
    computed :{
       ...mapGetters(['currentNe']),
    },
    methods: {
      upButton() {
        const fileDoms = document.getElementsByClassName('e-file-select-wrap');
        for(var i =0;i<fileDoms.length;i++){
           let item = fileDoms[i];
           if(item.querySelector('input').id == 'file'){
              item.querySelector('button').click();
           }
        }
        return false;
      },
      setCancel(param){
        this.brokenFlag = param;
      },
      async onFileSelect(args) {
        this.tryUtilFileLoaded();
      },
      tryUtilFileLoaded(){
        setTimeout(() => {
          try {
            const uploadPrefix = this.randomId();
            this.bigFileUpload(uploadPrefix);
          } catch (error) {
            this.tryUtilFileLoaded();
          }
        }, 100);
      },
      randomId() {
        const _temp = 'abcdefghijklmnopqrstuvwxyz';
        let randStr = '';
        for (let i = 0; i <= 8; i++) {
          randStr += _temp[Math.round(Math.random(1) * 26)];
        }
        return randStr;
      },
      getVersionList() {
        // 获取适配包版本号
        const url = '/lte/ems/packageManager/queryService';
        this.axios.get(url).then(res => {
          console.log(res.data);
          const list = res.data.map(item => item.pkgVersion);
          this.versionSource = Array.from(new Set(list));
        });
      },
      getParam() {
        // const index = this.$refs.versionList.ej2Instances.index;
        // const version = this.versionSource[index];
        let type = 0;
        // const radioGroup = document.getElementsByName('DeliverRadio');
        // radioGroup.forEach(item => {
        //   if(item.checked) {
        //   type = item.ej2_instances[0].value;
        //   }
        // });
        const file = this.$refs.file.ej2Instances.filesData[0];
        const param = {
          // version: version,
          file: file['rawFile'],
          fileType:file['type'],
          type: type
        };
        return param;
      },

      async checkExistPackage(){
        const url = '/lte/ems/packageManager/isPackageExist';
        const data = this.getParam();
        const fileName = data['file']['name'];
        const params = {
          fileName: fileName
        };
        let exist = new Boolean();
        await this.axios.get(url, { params }).then(res => {
          exist = res.data;
        });
        return exist;
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      },
      async bigFileUpload(uploadPrefix) {
        // 进度条
        this.brokenFlag = 0;
        const data = this.getParam();
        const srcFile = data['file'];
        // 如果文件为空，则退出
        if(!srcFile){
          this.eventEmit('warning', this.$t('System.fileNotNull'));
          return null;
        }
       // if(data['fileType'] != 'gz' && data['fileType'] != 'zip' && data['fileType'] != 'pkg'){
       //  this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
       //   return;
       // }
        /*if(srcFile.name.lastIndexOf(".lnk") != -1 || srcFile.name.lastIndexOf(".url") != -1){
          this.eventEmit('warning', this.$t('DeployManagement.invalidPackage'));
          return;
        }*/
        // 检查该文件是否上传过
        /*const isExist = await this.checkExistPackage();
        if (isExist) {
          this.eventEmit('warning', this.$t('DeployManagement.pkgExists'));
          return;
        }*/
        document.getElementById("uploadBtnDiv").style.display="none";
        EventBus.$emit("setChildProps", {status:0});
        const tempFiles = [];
        // 每片5M
        const perPiece = 1024 * 1024 * 50;
        let originalFilePath = '';
        let start = 0;
        let end = 0;
        let index = 0;
        let totalPieces = 0;
        let filesize = srcFile.size;
        let filename = srcFile.name;
        // 计算文件切片总数
        totalPieces = filesize % perPiece == 0 ? filesize/perPiece : filesize/perPiece + 1;
        // 上传文件
        const url = '/lte/ems/config/mml/bigFilePiece';
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          processData: false,
          async: false,
          contentType: false
        };
        let pecent = 0;
        this.showProgressBar = true;
        while((start < filesize) && this.brokenFlag == 0) {
          // 切片上传
          end = start + perPiece;
          if(end > filesize) {
            // 一次性上传
            end = filesize;
          }
          // 分割文件核心部分slice
          const chunk = srcFile.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk, filename);
          formData.append("totalPieces", totalPieces);
          formData.append("index", index);
          formData.append("process", pecent);
          formData.append("prefix", uploadPrefix);
          await this.$axios.post(url, formData, config).then(response => {
            const result = response['data']['resultVal'];
            tempFiles.push(result['msg']);
            originalFilePath = result['message'];
            // // 进度条
            pecent=((100*(end)/filesize)/4).toFixed(2);
            if(pecent>=100){
              pecent=100.00;
            }
            this.progressVal = pecent;
            this.progressText = pecent + '%';
          });
          start = end;
          index ++;
        }
        if(this.brokenFlag == 0){
          this.mergeBigFile(tempFiles, originalFilePath, uploadPrefix, filename);
        }else{
          this.clearCancelTempFile(uploadPrefix);
        }
      },
      clearCancelTempFile(prefix){
        const url = '/lte/ems/config/mml/clearCancelTempFile';
        const param = {
          prefix: prefix
        };
        this.$axios.post(url, param).then(res => {
          console.log("clear cancel tempFile...");
        });
      },
      mergeBigFile(tempFiles, originalFilePath, taskId, filename) {
        const url = '/lte/ems/config/mml/mergeBigFile';
        const param = {
          tempFiles: tempFiles,
          originalFilePath: originalFilePath,
          userId:this.getUserId()
        };
        this.progressText = this.$t('DeployManagement.mergeBigFile');
        this.$axios.post(url, param).then(res=> {
          if(res.data.errorCode == 'SUCCESS'){
            const data = this.getParam();
            console.log("data file.....", data);
            if(data['file']['name'].indexOf("eMS_NeAdapter_") > -1 || data['fileType'] == "pkg"){
              this.progressText = this.$t('System.processing');
              this.sendUpload(originalFilePath);
            }else{
              this.progressText = this.$t('DeployManagement.uploading');
              this.sendUpload(originalFilePath, taskId, filename);
            }
          }else{
            this.progressText = res.data.errorString;
          }
          EventBus.$emit("setChildProps", {status:1});
        });

      },
      sendUpload(originalFilePath, taskId, filename){
        const url = '/lte/ems/config/mml/uploadPackage';
        const param = {
          filePath: originalFilePath,
          taskId:taskId,
          currentNeId: this.currentNe.id,
          currentNeName: this.currentNe.name,
          channelId: this.getUserId()
        };
        const fileUrl = '';
        this.$axios.post(url, param, {timeout: 60 * 5 * 1000}).then(res => {
          if(res.data.errorCode == 'SUCCESS'){
            this.progressVal = 50;
            this.progressText = 50 + '%';
            ////this.progressText = this.$t('DeployManagement.uploadFinish');
            fileUrl = res.data.resultVal.url;
            console.log("fileUrl:"+fileUrl)
            const deviceSyncCfgUrl = '/lte/ems/config/mml/deviceASyncCfgRequest';
            const deviceSyncCfgParam = {
              url: fileUrl,
              equipmentId: this.currentNe.id
            };
           this.$axios.post(deviceSyncCfgUrl, deviceSyncCfgParam, {timeout: 60 * 5 * 1000}).then(res => {
              console.log(res.data)
              if(res.data.errorCode == 'SUCCESS'){
                 this.progressVal = 75;
                 this.progressText = 75 + '%';
              }else{
                 this.progressVal = 75;
                 this.progressText = 75 + '%';
              }
           });
          }else{
            this.progressText = res.data.errorString;
            return;
          }
        });

      },
      mmlWebsocketLisener(wsMessage) {
          console.log("mmlWebsocketLisener",wsMessage);
          const message = JSON.parse(wsMessage.body);
          console.log("dialog_message: "+ message.data);
          if( '3' == message.cmd){
            this.progressVal = 100;
            this.progressText = this.$t("MML.exeTimeOut");
          }
        }
    },
    destroyed() {
      this.brokenFlag = 1;
    },
    beforeDestroy(){
      mmlSocket.stopReceiveTopicMsg(this.getUserId(), '/user/#/MMLServer');
    },
    mounted() {
        mmlSocket.init(this.payload);
    }
  }
</script>
